import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { ExcelService } from '../common/API/excel.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import * as XLSX from 'ts-xlsx';
import { NotifierService } from 'angular-notifier';
import { WorkBook } from 'xlsx';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { BackRestrict } from '../common/backRestrict'
import { CommonService } from '../Services/common.service';
import { ApiService } from '../common/API/api.service';
import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
import { filter } from 'rxjs-compat/operator/filter';
import { fillProperties } from '@angular/core/src/util/property';
import { DeviceModel, DeviceCategory } from '../Models/DeviceData';

declare var config;

@Component({
  selector: 'app-upload-price-denmark',
  templateUrl: './upload-price-denmark.component.html',
  styleUrls: ['./upload-price-denmark.component.css']
})
export class UploadPriceDenmarkComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public IsOverridePhoneModel: false;

  public Enterprisedata = [];
  Enterpriselist: any;
  public dataTableID: any = false;
  public data = [];
  public dataSource: any;
  public arrayBuffer: any;
  public excelSheetData: any[];
  public UploadExcelSheetData: any[];
  public CheckData: any[];
  public ExcelSheet: any;
  public readonly notifier: NotifierService;
  userinfo: any;
  ChoosefileName: any;
  public EnterprisePartnerID: any;
  public EnterpriseID: any;
  public CurrencyName: any;
  public showexcelSheetData = [];
  public SuccessfullyUplodedList = [];
  public UnSuccessfullyUplodedList = [];
  AllList: [];
  public onSuccess: boolean;
  public successData: boolean;
  public Alldata = [];
  form: FormGroup;
  logform: FormGroup;
  excelData: any;
  ExcelFilterData = [];
  unsuccessdata = [];
  FailLogs: boolean;
  public disabledexportBtn: boolean = true;
  FailModal: boolean;
  Successmodal: boolean;
  OriginalDeviceData: any;
  DeviceCategory: any;
  DeviceCategoryID: any;
  public displayedColumnsMobilePhones = ['SKUID','Grade', "DeviceModelID", 'DeviceVendor', 'DeviceModel', 'StorageCapacity', 'MeasurementUnitType', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedColumnsIMac = ['SKUID','Grade', "Make", 'Screen Size', 'Processor Speed', 'CPU', 'Model', 'Video Card', 'HDD', 'SSD', 'Fusion Drive', 'RAM', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedColumnsAppleWatch = ['SKUID','Grade', "Model", 'Size', 'Data Connection Type', 'Casing', 'Colour', 'Specs', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedColumnsTabletAndReader = ['SKUID','Grade', "Model", 'Edition', 'Screen Size', 'Space', 'Data Connection Type', 'Colour', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedColumnsConsoles = ['SKUID','Grade', "Make", 'Type', 'Space', 'Controller', 'Colour', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedColumnsCamera = ['SKUID','Grade', "Manufacturer", 'Model', 'Device Type', 'Colour', 'Video Quality', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedColumnsLenses = ['SKUID','Grade', "Make", 'Model', 'Focal Length', 'Aperture', 'Description', 'Colour', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedMacbook = ['SKUID','Grade', 'Model', 'Screen Size', 'Display Type', 'CPU', 'Year', 'Keyboard Type', 'RAM', 'SSD', 'Colour','Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  public displayedMicrosoftSurface = ['SKUID', 'Grade','DeviceModel', 'YearBuild', 'Screen Size', 'CPU', 'RAM', 'SSD', 'Network Type', 'Colour', 'Price', 'PriceStartDate', 'PriceEndDate', 'Response'];
  EnumMobilePhone = DeviceCategory.MobilePhones;
  EnumIMac = DeviceCategory.iMAC;
  EnumAppleWatch = DeviceCategory.AppleWatch;
  EnumMicrosoftSurface = DeviceCategory.MicrosoftSurface;
  EnumMacBook = DeviceCategory.Macbook;
  EnumTabletAndReader = DeviceCategory.TabletsAndReader;
  EnumConsoles = DeviceCategory.Consoles;
  EnumCamera = DeviceCategory.Camera;
  EnumLenses = DeviceCategory.Lenses;
  Enterprise: any;
  SelectModino: boolean = false;
  IsITAD: boolean = false;

  constructor(private _service: CommonService, private router: Router,
    private excelService: ExcelService, private formbuilder: FormBuilder, notifierService: NotifierService
    , private spinner: NgxSpinnerService, private backrestrict: BackRestrict, private renderer: Renderer2, private _apiService: ApiService) {
    this.form = formbuilder.group({
      EnterprisePartner: ['0', Validators.required],
      Enterprise: ['0', Validators.required]
    });

    this.logform = formbuilder.group({
      SKUID: [null],
      ModelName: [null],
      Capacity: [null],
      Brand: [null],
      Currency: [null],
      Price: [null],
      PriceStartDate: [null],
      PriceEndDate: [null],
      Response: [null]
    });
    this.notifier = notifierService;
  }

  ngOnInit() {
    debugger
    this.excelSheetData = [];
    this.ExcelFilterData = [];
    this.unsuccessdata = [];
    this.backrestrict.clearBrowserBackHistory();
    this.onSuccess = false;
    this.userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
    this.EnterprisePartnerID = 29;
    this.DeviceCategoryID = 0;
    this.EnterpriseID = "5";
    this.CurrencyName = "US Dollar";
    this.ChoosefileName = "Choose file";
    this.Enterprise = config.Enterprise;
    this.DeviceCategory = config.DeviceCategory;
    this.onChangeEnterprise("5");
  }

  onChangeEnterprise(event) {
    debugger
    this.IsITAD = false;
    this.DeviceCategoryID = config.DeviceCategoryID;
    if (event == "0" || this.DeviceCategoryID == 0) {
      this.disabledexportBtn = true;
      return false;
    }
    else if (event == "5") {
      this.disabledexportBtn = false;
      this.SelectModino = false;
      this.GetModelDetail();
    }
    else {
      this.disabledexportBtn = true;
      this.SelectModino = true;
      this.EnterprisePartnerID = "29";
      this.getEnterprise_EnterprisePartner();
    }
    this.excelSheetData = [];
    this.fileUpload.nativeElement.value = '';
    this.ChoosefileName = "Choose file";
    this.DeviceCategoryID = this.DeviceCategoryID;
    this.disabledexportBtn = true;
    $('#Browse_span').removeClass('disabled');
    this.onSuccess = false;
  }

  getEnterprise_EnterprisePartner() {
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/get-store').subscribe(result => {
      debugger;
      this.spinner.hide();
      if (result.IsSuccess) {
        this.Enterpriselist = result.Data.Table1.filter(X => X.IsActive !== false);
        this.Enterprisedata = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseID && X.IsActive !== false);
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  OnChangeDeviceCategory(deviceCategoryID) {
    debugger;
    this.onSuccess = false;
    this.DeviceCategoryID = +deviceCategoryID;
    if (deviceCategoryID != "0") {
      this.disabledexportBtn = false;
      this.excelSheetData = [];
      this.fileUpload.nativeElement.value = '';
      this.ChoosefileName = "Choose file";
      this.GetModelDetail();
    }
    else {
      this.notifier.notify('error', 'Please choose device category');
    }
  }

  OnChangeEnterprisePartner(PartnerID) {
    this.disabledexportBtn = false;
    this.excelSheetData = [];
    this.fileUpload.nativeElement.value = '';
    this.ChoosefileName = "Choose file";
    this.GetModelDetail();
  }

  GetDeviceCategory() {
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/GetDeviceCategory').subscribe(result => {
      this.DeviceCategory = result;
    },
      error => {
        console.log(error);
      }
    );
    setTimeout(() => {
      this.spinner.hide();
    }, 5000);
  }

  GetModelDetail() {
    debugger
    if (this.EnterpriseID == "5") {
      // TODO: set the correct EnterprisePartnerID for Telenor Denmark
      this.EnterprisePartnerID = "29";
    }
    this.spinner.show();

    var param = {
      EnterprisePartnerID: this.EnterprisePartnerID,
      DeviceCategoryID: this.DeviceCategoryID,
      IsModelOverride: true
    }
    this._service.PostPartner(param, 'api/Pricing/getmodeldetailsforprice').then(
      (result: DeviceModel[]) => {
        debugger;
        this.disabledexportBtn = false;
        if (result !== null && result.length > 0) {
          this.spinner.hide();
          this.OriginalDeviceData = result;
          this.data = [];
          var deviceModel = this.GrtFilteredExcelData(result);
          deviceModel.forEach(element => {
            delete element.Response
          });
          const strtext = JSON.parse(JSON.stringify(deviceModel).split('PriceEndDate').join('PriceEndDate(mm-dd-yyyy hh:mm:ss)')
            .split('PriceStartDate').join('PriceStartDate(mm-dd-yyyy hh:mm:ss)'));
          this.data = strtext;
        }
        else {
          this.spinner.hide();
          console.log('error ');
        }
      },
      error => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }

  GrtFilteredExcelData(deviceInfo: DeviceModel[]): any {
    var deviceModel = [];

    switch (this.DeviceCategoryID) {
      case DeviceCategory.MobilePhones:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Grade: element.Grade,
            DeviceModelID: element.DeviceModelID,
            DeviceModel: element.DeviceModel,
            DeviceVendor: element.DeviceVendor,
            StorageCapacity: element.StorageCapacity,
            MeasurementUnitType: element.MeasurementUnitType,
            DeviceModelFullName: element.DeviceModelFullName,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;

      case DeviceCategory.iMAC:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Make: element.DeviceVendor,
            "Screen Size": element.ScreenSize,
            "Processor Speed": element.ProcessorSpeed,
            CPU: element.CPU,
            Model: element.DeviceModel,
            "Video Card": element.VideoCard,
            HDD: element.HDD,
            SSD: element.SSD,
            "Fusion Drive": element.FusionDrive,
            RAM: element.RAM,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.AppleWatch:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Grade: element.Grade,
            DeviceVendor: element.DeviceVendor,
            Model: element.DeviceModel,
            Size: element.DeviceSize,
            "Data Connection Type": element.DeviceConnectionType,
            Casing: element.DeviceCasing,
            Colour: element.DeviceColor,
            Specs: element.DeviceSpecification,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.TabletsAndReader:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Model: element.DeviceModel,
            Edition: element.DeviceManufactureYear,
            "Screen Size": element.ScreenSize,
            Space: element.StorageCapacity,
            "Data Connection Type": element.DeviceConnectionType,
            Colour: element.DeviceColor,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.Consoles:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Make: element.DeviceModel,
            Type: element.DeviceType,
            Space: element.StorageCapacity,
            Controller: element.DeviceSpecification,
            Colour: element.DeviceColor,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.Camera:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Manufacturer: element.DeviceVendor,
            Model: element.DeviceModel,
            "Device Type": element.DeviceType,
            Colour: element.DeviceColor,
            "Video Quality": element.DeviceVideoQuality,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.Lenses:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Make: element.DeviceVendor,
            Model: element.DeviceModel,
            "Focal Length": element.DeviceSize,
            Aperture: element.DeviceAperture,
            Description: element.DeviceSpecification,
            Colour: element.DeviceColor,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.Macbook:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            Model: element.DeviceModel,
            "Screen Size": element.ScreenSize,
            "Display Type": element.DeviceDisplayType,
            CPU: element.CPU,
            RAM: element.RAM,
            SSD: element.SSD,
            Year: element.DeviceManufactureYear,
            "Keyboard Type": element.DeviceKeyboardType,
            Colour: element.DeviceColor,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
      case DeviceCategory.MicrosoftSurface:
        deviceInfo.map(element =>
          deviceModel.push({
            SKUID: element.SKUID,
            DeviceModel: element.DeviceModel,
            YearBuild: element.DeviceManufactureYear,
            "Screen Size": element.ScreenSize,
            CPU: element.CPU,
            RAM: element.RAM,
            SSD: element.SSD,
            "Network Type": element.DeviceConnectionType,
            Colour: element.DeviceColor,
            Price: element.Price,
            "PriceStartDate": element.PriceStartDate,
            "PriceEndDate": element.PriceEndDate,
            Response: element.Response
          }));
        break;
    }
    return deviceModel;
  }

  exportAsXLSX() {
    this.excelService.exportAsExcelFile(this.data, 'DeviceData');
  }
  exportSuccessAsXLSX() {
    this.spinner.show();
    var successExcelData = this.GrtFilteredExcelData(this.SuccessfullyUplodedList);
    this.excelService.exportAsExcelFile(successExcelData, 'SuccessfullyUplodedList');
    this.spinner.hide();
  }
  exportUnsuccessAsXLSX() {
    this.spinner.show();
    var unSuccessExcelData = this.GrtFilteredExcelData(this.UnSuccessfullyUplodedList);
    this.excelService.exportAsExcelFile(unSuccessExcelData, 'UnSuccessfullyUplodedList');
    this.spinner.hide();
  }
  exportAllAsXLSX() {
    this.excelService.exportAsExcelFile(this.Alldata, 'AllList');
  }

  Clear() {
    this.excelSheetData = [];
    this.fileUpload.nativeElement.value = '';
    this.onSuccess = false;
    this.ChoosefileName = "Choose file";
    this.EnterprisePartnerID = "29";
    this.EnterpriseID = "5";
    this.disabledexportBtn = true;
    this.SelectModino = false;
  }

  clearFiledta() {
    this.excelSheetData = [];
    this.fileUpload.nativeElement.value = '';
    this.ChoosefileName = "Choose file";
  }

  onFileChanged(event) {
    debugger;
    this.onSuccess = false;
    this.unsuccessdata = [];
    this.excelSheetData = [];
    this.ExcelFilterData = [];
    if (this.EnterprisePartnerID == '0') {
      this.notifier.notify('error', 'Please choose enterprise');
      this.fileUpload.nativeElement.value = '';
    }
    else if (this.DeviceCategoryID == '0') {
      this.notifier.notify('error', 'Please choose device category');
      this.fileUpload.nativeElement.value = '';
    }
    else {
      if (event.target.files[0] != undefined && event.target.files[0].name.split('.').pop() === 'xlsx') {
        this.spinner.show();
        this.ChoosefileName = event.target.files[0].name;
        this.ExcelSheet = event.target.files[0];
        this.getExcelFile();
      }
      else {
        this.notifier.notify('error', 'Please choose excel file');
        this.fileUpload.nativeElement.value = '';
        this.ChoosefileName = "Choose file";
      }
    }
  }

  getDataForGrades() {
    console.log(this.unsuccessdata.filter(x => x.SKUID == 4559));
    var invalidSKUList = this.ExcelFilterData.filter(x => this.unsuccessdata.find(u => u.SKUID == (x.SKUID)));
    this.ExcelFilterData = this.ExcelFilterData.filter(x => !invalidSKUList.find(u => u.SKUID == (x.SKUID)));
    invalidSKUList.forEach(element => {
      var data = this.unsuccessdata.filter(x => x.SKUID == element.SKUID)[0];
      element.Response = 'Invalid data for other grades';
      element.DeviceModel = data.DeviceModel;
      element.DeviceVendor = data.DeviceVendor;
      element.DeviceModelID = data.DeviceModelID;
      element.MeasurementUnitType = data.MeasurementUnitType;
      element.StorageCapacity = data.StorageCapacity;
      this.unsuccessdata.push(element);
    })
  }

  getExcelFile() {
    debugger
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join('');
      let workbook: WorkBook = XLSX.read(bstr, { type: 'binary' });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      var excel_data = XLSX.utils.sheet_to_json(worksheet, { raw: false });
      this.UploadExcelSheetData = excel_data;
      this.excelSheetData = [];
      excel_data.forEach(current_value => {
        const updateModelsPrice = {
          SKUID: current_value['SKUID'],
          Grade: current_value['Grade'],
          Price: current_value['Price'],
          PriceStartDate: current_value['PriceStartDate(mm-dd-yyyy hh:mm:ss)'],
          PriceEndDate: current_value['PriceEndDate(mm-dd-yyyy hh:mm:ss)'],
          EnterprisePartnerID: this.EnterprisePartnerID,
        };
        this.excelSheetData.push(updateModelsPrice);
      });

      this.excelData = this.excelSheetData;
      if (excel_data.length < 1 || this.excelData[0].SKUID === undefined) {
        debugger
        this.fileUpload.nativeElement.value = '';
        this.notifier.notify('error', 'Excel is not in proper format');
        this.ChoosefileName = "Choose file";
        this.excelSheetData = [];
        this.spinner.hide();
      }
      else if (!excel_data[0].hasOwnProperty('PriceStartDate(mm-dd-yyyy hh:mm:ss)')) {
        this.fileUpload.nativeElement.value = '';
        this.notifier.notify('error', 'Excel is not in proper format');
        this.ChoosefileName = "Choose file";
        this.excelSheetData = [];
        this.spinner.hide();
      }
      else if (!excel_data[0].hasOwnProperty("PriceEndDate(mm-dd-yyyy hh:mm:ss)")) {
        this.fileUpload.nativeElement.value = '';
        this.notifier.notify('error', 'Excel is not in proper format');
        this.ChoosefileName = "Choose file";
        this.excelSheetData = [];
        this.spinner.hide();
      }
      else {
        this.getFilterData();
      }
    }
    if ($('#reading_txt').val(this.ExcelSheet.name) === '') {
      $('#reading_txt').val(this.ExcelSheet.name);
    }
    fileReader.readAsArrayBuffer(this.ExcelSheet);
  }

  Upload() {
    debugger
    this.spinner.show();
    this.FailLogs = false;
    this.onSuccess = false;
    this.successData = false;
    var _ValidData = this.ExcelFilterData;
    this.UnSuccessfullyUplodedList = this.unsuccessdata;
    this.Alldata = this.excelSheetData.map(element => {
      return {
        SKUID: element.SKUID,
        Grade: element.Grade,
        ModelName: element.ModelName,
        Brand: element.Brand,
        Currency: element.Currency,
        Price: element.Price == undefined ? '' : element.Price,
        PriceStartDate: element.PriceStartDate,
        PriceEndDate: element.PriceEndDate
      };
    });
    if (this.ExcelFilterData != null && this.ExcelFilterData.length > 0) {
      debugger
      this._service.PostPartner(_ValidData, 'api/Pricing/uploadPrice').then((result: any) => {
        this.clearFiledta();
        if (result !== null && result.length > 0) {
          debugger
          this.SuccessfullyUplodedList = [],
            this.showexcelSheetData = [];

          var errordata = result.filter(x => x.Response.includes('Error'));
          if (errordata != null && errordata != undefined && errordata.length > 0) {
            for (var i = 0; i < errordata.length; i++) {
              var errresponseData = this.UploadExcelSheetData.filter(x => x.SKUID == errordata[i].SKUID && x.Grade == errordata[i].Grade);
              if (errresponseData != null && errresponseData != undefined && errresponseData.length > 0) {
                errresponseData[0].Response = errordata[i].Response;
                errresponseData[0].PriceStartDate = errordata[i]["PriceStartDate(mm-dd-yyyy hh:mm:ss)"];
                errresponseData[0].PriceEndDate = errordata[i]["PriceEndDate(mm-dd-yyyy hh:mm:ss)"];
              }
              this.UnSuccessfullyUplodedList.push(errresponseData[0]);
            }
          }

          var Successdata = result.filter(x => x.Response.includes('Successfully'));
          if (Successdata != null && Successdata != undefined && Successdata.length > 0) {
            for (var i = 0; i < Successdata.length; i++) {
              var resData = this.UploadExcelSheetData.filter(x => x.SKUID == Successdata[i].SKUID && x.Grade == Successdata[i].Grade);
              if (resData != null && resData != undefined && resData.length > 0) {
                resData[0].Response = Successdata[i].Response;
                resData[0].PriceStartDate = Successdata[i]["PriceStartDate(mm-dd-yyyy hh:mm:ss)"];
                resData[0].PriceEndDate = Successdata[i]["PriceEndDate(mm-dd-yyyy hh:mm:ss)"];
                this.SuccessfullyUplodedList.push(resData[0]);
              }
            };
          }

          this.SuccessfullyUplodedList = this.SuccessfullyUplodedList;
          this.showexcelSheetData = this.SuccessfullyUplodedList;
          this.onSuccess = true;

          if (result !== null && result.length > 0 && this.unsuccessdata.length > 0) {
            if (this.SuccessfullyUplodedList.length == 0) {
              this.successData = false;
            } else {
              this.successData = true;
            }
            this.FailLogs = true;
            this.GetModelDetail();
            this.spinner.hide();
            this.notifier.notify('warning', 'Price uploaded successfully with some fail Logs');
          }
          else if (result !== null && result.length > 0) {
            this.successData = true;
            this.GetModelDetail();
            this.spinner.hide();
            this.notifier.notify('success', 'Price uploaded successfully');
          }
          else if (this.unsuccessdata.length > 0) {
            this.FailLogs = true;
            this.spinner.hide();
            this.notifier.notify('warning', 'Price not uploaded  with some fail Logs');
          }
          else {
            this.onSuccess = false;
            this.spinner.hide();
            this.notifier.notify('error', 'Price not uploaded due to wrong data or missing data');
          }
        }
        else {
          this.clearFiledta();
          this.spinner.hide();
          this.notifier.notify('error', 'Something went wrong');
        }
      },
        error => {
          this.spinner.hide();
          console.log(error);
          this.clearFiledta();
          this.notifier.notify('error', 'An error occured');
        });
    }
    else {
      this.spinner.hide();
      this.clearFiledta();
      this.onSuccess = true;
      this.FailLogs = true;
      this.notifier.notify('warning', 'Price not uploaded with some fail Logs');
    }
  }

  getFilterData() {
    debugger
    this.excelSheetData.forEach(element => {
      var _CurrentDate = new Date();
      var _CurrentUtcDate = new Date(_CurrentDate.getUTCFullYear(), _CurrentDate.getUTCMonth(), _CurrentDate.getUTCDate(), _CurrentDate.getUTCHours(), _CurrentDate.getUTCMinutes(), _CurrentDate.getUTCSeconds());
      _CurrentUtcDate = new Date(_CurrentUtcDate.toDateString());
      var pSdate: any;
      var pEdate: any;
      if (navigator.userAgent.search('Firefox') > 1) {
        pSdate = new Date(element.PriceStartDate ? element.PriceStartDate.replaceAll('-', '/') : element.PriceStartDate);
        pEdate = new Date(element.PriceEndDate ? element.PriceEndDate.replaceAll('-', '/') : element.PriceEndDate);
      }
      else {
        pSdate = new Date(element.PriceStartDate);
        pEdate = new Date(element.PriceEndDate);
      }
      var _pSdateZero = new Date(pSdate.toDateString());
      var _pEdateZero = new Date(pEdate.toDateString());

      if (element.Price !== "" && element.Price !== undefined && this.priceDecCount(element.Price)
        && !isNaN(_pSdateZero.getTime()) && _pSdateZero >= _CurrentUtcDate
        && !isNaN(_pEdateZero.getTime()) && _pEdateZero > _pSdateZero && this.data.some(item => item.SKUID == element.SKUID)
        && !isNaN(element.Price) && (element.Price) > 0) {

        this.ExcelFilterData.push(
          {
            SKUID: element.SKUID,
            Grade: element.Grade,
            Price: (element.Price == undefined) ? '' : element.Price,
            PriceStartDate: pSdate.getDate() + '/' + (pSdate.getMonth() + 1) + '/' + pSdate.getFullYear() + ' ' + pSdate.getHours() + ':' + pSdate.getMinutes() + ':' + pSdate.getSeconds(),
            PriceEndDate: pEdate.getDate() + '/' + (pEdate.getMonth() + 1) + '/' + pEdate.getFullYear() + ' ' + pEdate.getHours() + ':' + pEdate.getMinutes() + ':' + pEdate.getSeconds(),
            EnterprisePartnerID: this.EnterprisePartnerID,
            EnterpriseID: this.EnterpriseID,
            DeviceCategoryID: this.DeviceCategoryID
          });
      }
      else if ((element.SKUID !== "" && element.SKUID !== undefined)) {
        debugger;
        var _ErrorMessage = '';
        if ((element.Price === "" || element.Price === undefined || isNaN(element.Price) || (element.Price) <= 0
          || !(this.priceDecCount(element.Price)))) {
          _ErrorMessage = 'Error:-Invalid price';
        }
        else if (isNaN(_pSdateZero.getTime())) {
          _ErrorMessage = 'Error:-Invalid Start Date';
        }
        else if (_pSdateZero < _CurrentUtcDate) {
          _ErrorMessage = 'Error:-Start Date must be greater than or equal to Today Date';
        }
        else if (isNaN(_pEdateZero.getTime())) {
          _ErrorMessage = 'Error:-Invalid End Date';
        }
        else if (_pEdateZero <= _pSdateZero) {
          _ErrorMessage = 'Error:-End Date must be greater than Start Date';
        }
        else if (this.data.some(item => item.SKUID !== element.SKUID)) {
          _ErrorMessage = 'Error:-SKUID did not match';
        }
        var errorList: DeviceModel;
        errorList = this.OriginalDeviceData.filter(x => x.SKUID == element.SKUID && x.Grade == element.Grade)[0];
        if (errorList) {
          errorList.Price = element.Price;
          errorList.PriceStartDate = (this.dateformat(element.PriceStartDate) === "") ? element.PriceStartDate : this.dateformat(element.PriceStartDate),
            errorList.PriceEndDate = (this.dateformat(element.PriceEndDate) === "") ? element.PriceEndDate : this.dateformat(element.PriceEndDate),
            errorList.Response = _ErrorMessage;
        } else {
          errorList = new DeviceModel();
          errorList = element;
          errorList.Response = _ErrorMessage;
        }
        this.unsuccessdata.push(errorList);
      }
    });
    this.spinner.hide();
    this.getDataForGrades();
  }

  isNumber(num): boolean {
    return parseInt(num) === num;
  }

  successModal() {
    this.dataTableID = true;
    this.Successmodal = true;
    this.FailModal = false;
    const strtext = JSON.parse(JSON.stringify(this.SuccessfullyUplodedList).split('PriceEndDate(mm-dd-yyyy hh:mm:ss)').join('PriceEndDate')
      .split('PriceStartDate(mm-dd-yyyy hh:mm:ss)').join('PriceStartDate'));
    this.dataSource = new MatTableDataSource(strtext);
    setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
  }

  failModal() {
    this.dataTableID = true;
    this.FailModal = true;
    this.Successmodal = false;
    const strtext = JSON.parse(JSON.stringify(this.UnSuccessfullyUplodedList).split('PriceEndDate(mm-dd-yyyy hh:mm:ss)').join('PriceEndDate')
      .split('PriceStartDate(mm-dd-yyyy hh:mm:ss)').join('PriceStartDate'));
    this.dataSource = new MatTableDataSource(strtext);
    setTimeout(() => { this.dataSource.paginator = this.paginator; this.dataSource.sort = this.sort }, 100);
  }

  dateformat(_date) {
    _date = new Date(_date);
    if (!isNaN(_date.getTime())) {
      return (("0" + (_date.getMonth() + 1)).slice(-2)) + '-' + (("0" + _date.getDate()).slice(-2)) + '-'
        + _date.getFullYear() + ' ' + ("0" + _date.getHours()).slice(-2) + ':'
        + (("0" + _date.getMinutes()).slice(-2)) + ':' + (("0" + _date.getSeconds()).slice(-2));
    }
    else {
      return "";
    }
  }

  priceDecCount(e) {
    if (e !== undefined) {
      var eL = e.toString().split(".").length;
      if (eL == 1) {
        return true;
      }
      else if (eL > 2) {
        return false;
      }
      else if (eL == 2) {
        var res = e.toString().split(".")[1].length
        if (res > 2) {
          return true;
        }
        else {
          return true;
        }
      }
    }
    else {
      return false;
    }
  }

}
